import {Switch, Route} from 'react-router-dom'
import {Component} from 'react'

import ThemeContext from './Context/ThemeContext'
import ProtectedRoute from './components/ProtectedRoute'
import LoginPage from './components/LoginPage'
import Home from './components/Home'
import BookShelves from './components/BookShelves'

import './App.css'

// use the below bookshelvesList for rendering read status of book items in Bookshelves Route

class App extends Component {
  state = {isDark: false}

  toggleTheme = () => {
    this.setState(prevState => ({
      isDark: !prevState.isDark,
    }))
  }

  render() {
    const {isDark} = this.state
    return (
      <ThemeContext.Provider
        value={{theme: isDark, toggleTheme: this.toggleTheme}}
      >
        <Switch>
          <Route exact path="/login" component={LoginPage} />
          <ProtectedRoute exact path="/" component={Home} />
          <ProtectedRoute exact path="/shelf" component={BookShelves} />
        </Switch>
      </ThemeContext.Provider>
    )
  }
}
export default App
